<template>
  <tbody>
    <tr v-for="item in items" :key="item.id" class="text-xs-center hovereable" @click="editItemWithEvent($event, item.id)">
      <td width="10%">
        <v-icon x-large class="k-orange-linear-text text--darken-2">fas fa-user</v-icon>
      </td>
      <td class="text-xs-left">
        {{ item.first_name }} {{ item.last_name }}
        <small>{{ item.email }}</small>
      </td>
      <td>
        {{ item.role.display_name }}
      </td>
      <td>
        <small>Última actividad</small>
        {{ formatDate(item.last_activity, 'DD/MM/YYYY') }}
      </td>
      <td>
        <small>Fecha de creación</small>
        {{ item.created_at ? formatDate(item.created_at.date, 'DD/MM/YYYY') : 'Sin especificar' }}
      </td>
      <td  width="15%">
        <v-chip medium class="green white--text" v-if="item.status === 'activo'">
          <v-icon class="pr-2 white--text" small>fas fa-check</v-icon>
          Activo
        </v-chip>
        <v-chip medium class="blue lighten-2 white--text" v-if="item.status === 'pendiente'">
          <v-icon class="pr-2 white--text" small>fas fa-clock</v-icon>
          Pendiente
        </v-chip>
        <v-chip medium class="grey darken-0 white--text" v-if="item.status === 'inactivo'">
          <v-icon class="pr-2 white--text" small>fas fa-user-slash</v-icon>
          Inactivo
        </v-chip>
        <v-chip medium class="grey darken-0 white--text" v-if="item.status === 'bloqueado'">
          <v-icon class="pr-2 white--text" small>fas fa-user-slash</v-icon>
          Bloqueado
        </v-chip>
      </td>
      <td>
        <v-menu bottom offset-y>
          <v-btn slot="activator" color="grey darken-2" small flat fab>
            <v-icon>fas fa-ellipsis-v</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="changeStatus(item.id, item.status)">
              <v-list-tile-title>
                <template v-if="item.status === 'activo'">
                  Desactivar
                </template>
                <template v-else-if="item.status === 'inactivo' || item.status === 'pendiente' || item.status === 'bloqueado'">
                  Activar
                </template>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="changeUPassword(item)" v-if="item.id !== $auth.user().id">
              <v-list-tile-title>Cambiar contraseña</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="changePermissions(item.id)">
              <v-list-tile-title>Permisos</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="editItemWithEvent(null, item.id)">
              <v-list-tile-title>Editar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="deleteItem(item.id, `a ${item.first_name} ${item.last_name}`)">
              <v-list-tile-title>Eliminar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </td>
    </tr>
  </tbody>
</template>

<script>
import moment from 'moment';
import dataTableMixin from '@/mixins/dataTableList';
import EventBus from '@/event-bus';

export default {
  mixins: [
    dataTableMixin,
  ],
  props: [
    'items',
  ],
  data() {
    return {
      route: 'users',
    };
  },
  methods: {
    formatDate(date, dateFormat) {
      let dateFormatted = '';
      if (!date) {
        dateFormatted = 'Nunca';
      } else {
        dateFormatted = moment(date, 'YYYY-MM-DD').format(dateFormat);
      }
      return dateFormatted;
    },
    changePermissions(id) {
      EventBus.$emit('changePermissions', id);
    },
    changeUPassword(user) {
      EventBus.$emit('changePassword', user);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/user/UsersList.vue